// extracted by mini-css-extract-plugin
export default {"select":"View_select__OibFG","checkbox":"View_checkbox__7TcOF","container":"View_container__sNGQT"};